import './GreenAssetFinanceScheme.css'
import React, { useEffect } from "react";
import AllAcountsSection from "../../Components/AllAccountsSection/AllAcountsSection";
import Breadcrumb from "../../Components/Breadcrumb/Breadcrumb";
import SavePlusAccountComponent from "../../Components/SavePlusAccount/SavePlusAccountComponent";

import AutoFinanceAccordion from "../AutoFinance/AutoFinanceAccordion";
// import { question } from "../AutoFinance/AutoFinanceData";
import { IndoGreenAssetData } from './IndoGreenAssetData';
import IndoGreenAccordion from './IndoGreenAccordion';
// console.log(question);

const IndoGreenAssetFinanceScheme = () => {
    const Arrow_down = "https://izbassetsmain.blob.core.windows.net/izbwebassets/arrow_down.png";
    const img1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB-21.png";
    const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/autofinance-banner.png";
    
    const Img1 ="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-green-asset-finance-mod-1.png"
    const Img2 ="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-green-asset-finance-mod-2.png"
    const Img3 ="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-green-asset-finance-mod-3.png"
    const Img4 ="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-green-asset-finance-mod-4.png"

      useEffect(() => {
        window.scrollTo(0, 0)
      }, [])
      const accountContent =
        "Purchase of brand new and second hand utility vehicle.Age of Second- hand vehicle not to exceed 5 years.";
      return (
        <>
          <section className="IndoGreenAssetFinanceSchemeSection">
            <Breadcrumb Heading="Indo Green Asset Finance Scheme." img={BackgroundBrundcrumb} show={true} btnTxt="Apply Now" />

            <div className="IndoGreenAssetFinanceSchemeSection_hero-sec">
                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/Energy_Banner 1.png" className="hide-on-mobile" />
                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/Energy_Banner_Mobile 1.png" className="hide-on-desktop" />
            </div>

            {/* <div className="IndoGreenAssetFinanceSchemeSection_benefits container">
                <div className="IndoGreenAssetFinanceSchemeSection_benefits-list">
                    <div className="IndoGreenAssetFinanceSchemeSection_benefits-list-title">
                        <p>The products available under the scheme are:</p>
                    </div>
                    <div className="IndoGreenAssetFinanceSchemeSection_benefits-list-desc">
                        <ul>
                            <li>
                                <span>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_1975_3864)">
                                        <path d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z" fill="#484848"/>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_1975_3864">
                                        <rect width="24" height="24" fill="white"/>
                                        </clipPath>
                                        </defs>
                                    </svg>
                                </span>
                                <span>Solar lighting systems (solar panel, invertor, batteries etc.)</span>
                            </li>
                            <li>
                                <span>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_1975_3864)">
                                        <path d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z" fill="#484848"/>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_1975_3864">
                                        <rect width="24" height="24" fill="white"/>
                                        </clipPath>
                                        </defs>
                                    </svg>
                                </span>
                                <span>Solar water system (domestic and commercial use)</span>
                            </li>
                            <li>
                                <span>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_1975_3864)">
                                        <path d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z" fill="#484848"/>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_1975_3864">
                                        <rect width="24" height="24" fill="white"/>
                                        </clipPath>
                                        </defs>
                                    </svg>
                                </span>
                                <span>Gas stoves</span>
                            </li>
                            <li>
                                <span>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_1975_3864)">
                                        <path d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z" fill="#484848"/>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_1975_3864">
                                        <rect width="24" height="24" fill="white"/>
                                        </clipPath>
                                        </defs>
                                    </svg>
                                </span>
                                <span>Solar geysers, etc.</span>
                            </li>
                        </ul>
                        <p>The scheme is available to both individuals and businesses.</p>
                    </div>
                </div>

                <div className="IndoGreenAssetFinanceSchemeSection_benefits-list">
                    <div className="IndoGreenAssetFinanceSchemeSection_benefits-list-title">
                        <p>Requirements:</p>
                    </div>
                    <div className="IndoGreenAssetFinanceSchemeSection_benefits-list-desc">
                        <ul>
                            <li>
                                <span>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_1975_3864)">
                                        <path d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z" fill="#484848"/>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_1975_3864">
                                        <rect width="24" height="24" fill="white"/>
                                        </clipPath>
                                        </defs>
                                    </svg>
                                </span>
                                <span>Payslip (For individuals)</span>
                            </li>
                            <li>
                                <span>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_1975_3864)">
                                        <path d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z" fill="#484848"/>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_1975_3864">
                                        <rect width="24" height="24" fill="white"/>
                                        </clipPath>
                                        </defs>
                                    </svg>
                                </span>
                                <span>Quotation from our authorized list of supplies</span>
                            </li>
                            <li>
                                <span>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_1975_3864)">
                                        <path d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z" fill="#484848"/>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_1975_3864">
                                        <rect width="24" height="24" fill="white"/>
                                        </clipPath>
                                        </defs>
                                    </svg>
                                </span>
                                <span>Fill in the application form</span>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="IndoGreenAssetFinanceSchemeSection_benefits-list">
                    <div className="IndoGreenAssetFinanceSchemeSection_benefits-list-title">
                        <p>List of Suppliers Under Indo Green Asset Finance Scheme:</p>
                    </div>
                    <div className="IndoGreenAssetFinanceSchemeSection_benefits-list-desc">
                        <ul>
                            <li>
                                <span>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_1975_3864)">
                                        <path d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z" fill="#484848"/>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_1975_3864">
                                        <rect width="24" height="24" fill="white"/>
                                        </clipPath>
                                        </defs>
                                    </svg>
                                </span>
                                <span>Vew Investments</span>
                            </li>
                            <li>
                                <span>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_1975_3864)">
                                        <path d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z" fill="#484848"/>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_1975_3864">
                                        <rect width="24" height="24" fill="white"/>
                                        </clipPath>
                                        </defs>
                                    </svg>
                                </span>
                                <span>Saro Agro Industries Limited</span>
                            </li>
                            <li>
                                <span>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_1975_3864)">
                                        <path d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z" fill="#484848"/>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_1975_3864">
                                        <rect width="24" height="24" fill="white"/>
                                        </clipPath>
                                        </defs>
                                    </svg>
                                </span>
                                <span>Davis and Shirtliff</span>
                            </li>
                            <li>
                                <span>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_1975_3864)">
                                        <path d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z" fill="#484848"/>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_1975_3864">
                                        <rect width="24" height="24" fill="white"/>
                                        </clipPath>
                                        </defs>
                                    </svg>
                                </span>
                                <span>Newtech Business Systems Limited</span>
                            </li>
                            <li>
                                <span>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_1975_3864)">
                                        <path d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z" fill="#484848"/>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_1975_3864">
                                        <rect width="24" height="24" fill="white"/>
                                        </clipPath>
                                        </defs>
                                    </svg>
                                </span>
                                <span>Next Solutions Zambia Limited</span>
                            </li>
                            <li>
                                <span>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_1975_3864)">
                                        <path d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z" fill="#484848"/>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_1975_3864">
                                        <rect width="24" height="24" fill="white"/>
                                        </clipPath>
                                        </defs>
                                    </svg>
                                </span>
                                <span>Pafriw Hardware</span>
                            </li>
                            <li>
                                <span>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_1975_3864)">
                                        <path d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z" fill="#484848"/>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_1975_3864">
                                        <rect width="24" height="24" fill="white"/>
                                        </clipPath>
                                        </defs>
                                    </svg>
                                </span>
                                <span>World of Solar</span>
                            </li>
                            <li>
                                <span>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_1975_3864)">
                                        <path d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z" fill="#484848"/>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_1975_3864">
                                        <rect width="24" height="24" fill="white"/>
                                        </clipPath>
                                        </defs>
                                    </svg>
                                </span>
                                <span>Radian Stores</span>
                            </li>
                            <li>
                                <span>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_1975_3864)">
                                        <path d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z" fill="#484848"/>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_1975_3864">
                                        <rect width="24" height="24" fill="white"/>
                                        </clipPath>
                                        </defs>
                                    </svg>
                                </span>
                                <span>Home Power Investments</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div> */}

            <section>
                <div className="container justify-content-center mt-5">
                    <div className="faq-style1__content">
                        <ul className="accordion-box mb-5">
                        {IndoGreenAssetData.map((item) => {
                            const { id } = item;
                            return <IndoGreenAccordion key={id} {...item} />;
                        })}
                        </ul>
                    </div>
                </div>
            </section>

            <div className="container call-or-mail">
                <p>Call <a href='tel:8802'>8002</a> or email <a href='mailto:credit@izb.co.zm'>credit@izb.co.zm</a> now to Apply</p>
            </div>

             {/* <div className="IndoGreenAssetFinanceSchemeSection_benefits-gallery container">
                <div className="row">
                    <div className='col-6 col-md-6'>
                        <img src={Img1} alt="Indo-Green-Asset-Finance-Scheme-gallery" />
                    </div>
                    <div className='col-6 col-md-6'>
                        <img src={Img2} alt="Indo-Green-Asset-Finance-Scheme-gallery" />
                    </div>
                    <div className='col-6 col-md-6'>
                        <img src={Img3} alt="Indo-Green-Asset-Finance-Scheme-gallery" />
                    </div>
                    <div className='col-6 col-md-6'>
                        <img src={Img4} alt="Indo-Green-Asset-Finance-Scheme-gallery" />
                    </div>
                </div>
             </div> */}

          </section>

          <AllAcountsSection />
        </>
      );
    };
    
export default IndoGreenAssetFinanceScheme